<template>
  <div class="row">
    <form class="col-12">
      <div class="form-group">
        <label class="text-primary" for="message-textarea"
          >Nachricht an <strong>{{ username }}</strong></label
        >
        <textarea
          class="form-control bg-light rounded"
          id="message-textarea"
          :placeholder="formPlaceholer"
          rows="3"
          v-model="message"
        ></textarea>
        <span v-if="!customer">{{ message.length }} / {{ minimumLength }}</span>
      </div>
      <button
        type="button"
        @click="$modal.hide(`modal-message-form`)"
        class="btn btn-success rounded float-right"
        :disabled="myselfViewing || minimumLengthReached"
      >
        Senden
      </button>
    </form>
  </div>
</template>
<script lang="babel">
export default {
    data () {
        return {
          message: '',
      };
    },
    methods: {
        sendMesasge: ()=>{
            //TODO: Send Message
        },
    },
    computed: {
        formPlaceholer(){
            if(this.myselfViewing)
               return "Du kannst die Nachricht nicht an Dich selbst verschicken!";
            else
               return "Schreibe eine Nachricht...";
        },
        minimumLengthReached() {
          if (this.customer) return true;
          return this.message.length < this.minimumLength;
        }
    },
    props: {
        myselfViewing: {
            reqiured: false,
            type: Boolean,
            default: false
        },
        username: {
            reqiured: true,
            type: String,
        },
        customer: {
            required: true,
            type: Boolean,
            // default: false,
        },
        minimumLength: {
            type: Number,
            default: 100,
        }
    }
  };
</script>
